"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListReplicaAdSnapshotQuerySchema = exports.ListReplicaAdQuerySchema = exports.UpdateReplicaAdsBodySchema = exports.UpdateReplicaAdBodySchema = exports.ListReplicaAdSnapshotResponseSchema = exports.ListReplicaAdResponseSchema = exports.ReplicaAdSnapshotSchema = exports.ReplicaAdSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const ad_reports_1 = require("./ad-reports");
const common_1 = require("./common");
exports.ReplicaAdSchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaMetadataFields,
    adRef: ruby_1.AppleProxyRefSchema,
    adGroupRef: ruby_1.AppleProxyRefSchema,
    body: apple_proxy_web_1.AppleProxyAdSchema,
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
    duration: core_1.DurationSchema,
});
exports.ReplicaAdSnapshotSchema = exports.ReplicaAdSchema;
/**
 * Responses
 */
exports.ListReplicaAdResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaAdSchema);
exports.ListReplicaAdSnapshotResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaAdSnapshotSchema);
/**
 * Body
 */
exports.UpdateReplicaAdBodySchema = (0, core_1.StrictObject)({
    body: apple_proxy_web_1.AppleProxyAdSchema,
});
exports.UpdateReplicaAdsBodySchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaMetadataFields,
    ads: typebox_1.Type.Array(exports.UpdateReplicaAdBodySchema),
});
/**
 * Parameters
 */
exports.ListReplicaAdQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaMetadataQueryFields,
    adRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    creativeType: typebox_1.Type.Optional(ad_reports_1.CreativeTypeQueryTypeSchema),
});
exports.ListReplicaAdSnapshotQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaMetadataSnapshotQueryFields,
    adRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    creativeType: typebox_1.Type.Optional(ad_reports_1.CreativeTypeQueryTypeSchema),
});
